module.exports = __webpack_public_path__ + "static/Configurable_fiscal_period_hires-7f3a180329d9055ae8852935679deea4.jpg";